<template>
    <div>
        <p class="sr-only">Share via:</p>
        <ul class="flex gap-3 items-center">
            <li v-for="provider in providers">
                <a
                    :href="provider.url"
                    target="_blank"
                    class="bg-gray-175 flex group h-9 items-center justify-center rounded-full w-9"
                >
                    <component
                        :is="provider.icon"
                        :class="[provider.class]"
                        aria-hidden="true"
                    />
                    <span class="sr-only">{{ provider.name }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { computed } from "vue";
import IconFacebook from "./SvgPaths/IconFacebook.vue";
import IconX from "./SvgPaths/IconX.vue";
import IconLinkedIn from "./SvgPaths/IconLinkedIn.vue";
import EmailEnvelope from "./SvgPaths/EmailEnvelope.vue";

const props = defineProps(["url", "title", "summary"]);

function urlWithParams(base, params = {}) {
    return `${base}?${new URLSearchParams(params).toString()}`.replaceAll(
        "+",
        "%20"
    );
}

const providers = computed(() => [
    {
        icon: IconFacebook,
        class: "inline-block max-w-none fill-gray-550 w-4 group-hover:fill-black fill-gray-550 w-4 group-hover:fill-black",
        url: urlWithParams("https://www.facebook.com/sharer/sharer.php?", {
            u: props.url,
        }),
        name: "Facebook",
    },
    {
        icon: IconX,
        class: "inline-block max-w-none fill-gray-550 w-4 group-hover:fill-black fill-gray-550 w-4 group-hover:fill-black",
        url: urlWithParams("https://twitter.com/intent/tweet", {
            url: props.url,
            text: props.title,
            via: "seclock",
        }),
        name: "X",
    },
    {
        icon: IconLinkedIn,
        class: "inline-block max-w-none fill-gray-550 w-4 group-hover:fill-black fill-gray-550 w-4 group-hover:fill-black",
        url: urlWithParams("https://www.linkedin.com/shareArticle", {
            url: props.url,
            title: props.title,
            summary: props.summary,
        }),
        name: "LinkedIn",
    },
    {
        icon: EmailEnvelope,
        class: "inline-block max-w-none fill-gray-550 w-4 group-hover:fill-black fill-gray-550 w-4 group-hover:fill-black",
        url: urlWithParams("mailto:", {
            subject: props.title,
            body: [props.summary, props.url].filter((v) => v).join("\n\n"),
        }),
        name: "Email",
    },
]);
</script>
